import getSnippetInstance from '../zend-desk/get-snippet-instance';

const preload = async () => {
  await getSnippetInstance();
};

export default preload;
